import { SendToMailRequest, SendToMailResponse } from 'Application/models';
import { APICallInstance } from './APICallInstance';
import { AxiosResponse } from 'axios';

export const PostToMail = async (sendToMailData: SendToMailRequest, quoteId: string) => {
    const url = `api/v1/quotation/send/email?quoteId=${quoteId}`;

    try {
        const response: AxiosResponse<SendToMailResponse> = await APICallInstance.post(url, sendToMailData);
        console.log(response);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const PostPolicyToMail = async (policyNumber: string): Promise<void> => {
    const url = `api/v1/policy/send/email?policyNumber=${policyNumber}`;

    try {
        // Make the API call with a GET request (or POST depending on API, modify as needed)
        const response: AxiosResponse<void> = await APICallInstance.get(url);
        console.log(response);
    } catch (error) {
        console.error('Failed to send policy to email:', error);
        throw error;
    }
};
